import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';

import { Router, NavigationEnd } from '@angular/router';
import {
  MsalService,
  MsalBroadcastService,
  MSAL_GUARD_CONFIG,
  MsalGuardConfiguration
} from '@azure/msal-angular';
import { AuthenticationService } from '../../services/authentication.service';
import {
  EventMessage,
  EventType,
  InteractionStatus,
} from '@azure/msal-browser';
import { filter, Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-toolbar',
  standalone: true,
  imports: [MatToolbarModule, MatMenuModule],
  templateUrl: './toolbar.html',
  styleUrl: './toolbar.css'
})
export class Toolbar implements OnInit, OnDestroy {

  isIframe = false;
  isMyRequestsRoute = false; 
  private readonly _destroying$ = new Subject<void>();
  loginDisplay = false;
  public userName: string = '';
  public headerTitle: string = 'My Requests';

  constructor(
    private authenticationService: AuthenticationService,
    private msalBroadcastService: MsalBroadcastService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.setLoginDisplay();
    this.getUserName();
    this.checkAndSetActiveAccount();

    this.msalBroadcastService.inProgress$
      .pipe(
        filter((status: InteractionStatus) => status === InteractionStatus.None),
        takeUntil(this._destroying$)
      )
      .subscribe(() => {
        this.setLoginDisplay();
        this.getUserName();
      });

    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        if (this.router.url.includes('/all-requests')) {
          this.headerTitle = 'All Requests';
        } else if (this.router.url.includes('/my-requests') || this.router.url ==('/'))   {
          this.headerTitle = 'My Requests';
        } else {
          this.headerTitle = 'Plan Change Request';
        }
      });
  }

  setLoginDisplay() {
    this.loginDisplay = this.authenticationService.setLoginDisplay();
  }

  getUserName() {
    this.userName = this.authenticationService.getUserName();
  }

  checkAndSetActiveAccount() {
    this.authenticationService.checkAndSetActiveAccount();
  }

  loginRedirect() {
    this.authenticationService.loginRedirect();
  }

  loginPopup() {
    this.authenticationService.loginPopup();
  }

  ngOnDestroy(): void {
    this._destroying$.next();
    this._destroying$.complete();
    this.authenticationService.ngOnDestroy();
  }
}
